import type { LocalDatabaseRegister } from "../../../_Generated/Sync.gen";
import type { BaseRegisterRepository } from "../../_Bases/BaseRegisterRepository";
import type { InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBRegisterRepository extends BaseIndexedDBRepository<
    LocalDatabaseRegister
> implements BaseRegisterRepository {
    public readonly source: InternalIndexedDBDatabase["registers"];
    protected readonly dataTypeName = "Register";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.registers;
    }
}
